import { request } from '@/shared/api/request'

export const getHtml = (data, isEmployee = false) => {
	return request({ url: `colcontract/ecd/html?isEmployee=${isEmployee}`, method: 'POST', data: data })
}
